import { Card } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useEffect, useState } from 'react';
import { JournalEntry } from './models/JournalEntry';

function JournalListComponent() {
  const [journalEntries, setJournalEntries] = useState<JournalEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/journal-entries.json`)
      .then(res => res.json())
      .then(data => {
        setJournalEntries(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load journal entries:', err);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      { loading ?
        <p></p>
        :
        <div className='container'>
        { journalEntries.map(journalEntry =>
        <Card style={{ width: '25rem' }}>
          <Card.Body>
            <Card.Img src={`/img/${journalEntry.image}`}/>
            <Card.Title>{journalEntry.startLocation} to {journalEntry.endLocation}</Card.Title>
            <Card.Text><b>{journalEntry.endDate}.</b> {journalEntry.summary}</Card.Text>
            <Link
            style={{ display: "block", margin: "1rem 0" }}
            to={`/journal/${journalEntry.id}`}
            key={journalEntry.id}
          >
            Read More
          </Link>
          </Card.Body>
        </Card>
        )
        
        }
        </div>
      }
    </div>
  );
};

export default JournalListComponent;
